import React from 'react';
import styled from 'styled-components';
// import { Link } from 'react-router-dom';

const HomeContainer = styled.section`
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 80px;
`;

const HeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/images/salon_hd.jpg');
  background-size: cover;
  background-position: center;
  filter: brightness(0.6);
  z-index: -1;
`;

const HeroContent = styled.div`
  max-width: 800px;
  padding: 2rem;
  z-index: 1;
`;

const HeroTitle = styled.h1`
  font-family: 'Blackwood Castle', serif;
  font-size: 4rem;
  color: var(--gold);
  margin-bottom: 1.5rem;
  font-weight: 300;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    var(--gold) 0%,
    #fffbe6 40%,
    var(--gold) 60%,
    var(--gold) 100%
  );
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shine var(--shine-duration) linear infinite;

  @keyframes shine {
    to {
      background-position: 200% center;
    }
  }

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const HeroSubtitle = styled.h2`
  font-size: 1.8rem;
  color: var(--white);
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const HeroDescription = styled.p`
  font-size: 1.2rem;
  color: var(--white);
  margin-bottom: 2.5rem;
  line-height: 1.6;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const StyledButton = styled.a`
  background-color: var(--royal-blue);
  color: var(--gold);
  border: 2px solid var(--gold);
  padding: 0.75rem 1.5rem;
  font-family: 'Blackwood Castle', serif;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;
  text-decoration: none;

  &:hover {
    background-color: var(--gold);
    color: var(--royal-blue);
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
`;

const FeatureContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 3rem;
  width: 100%;
  max-width: 1200px;
  padding: 0 2rem;
`;

const FeatureCard = styled.div`
  background-color: var(--royal-blue);
  border: 2px solid var(--gold);
  padding: 2rem;
  border-radius: 5px;
  width: 300px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const FeatureTitle = styled.h3`
  font-family: 'Blackwood Castle', serif;
  font-size: 1.5rem;
  color: var(--gold);
  margin-bottom: 1rem;
`;

const FeatureDescription = styled.p`
  color: var(--white);
  line-height: 1.5;
`;

const SectionTitle = styled.h2`
  font-family: 'Blackwood Castle', serif;
  font-size: 2.5rem;
  color: var(--gold);
  margin-top: 4rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Home = () => {
  return (
    <HomeContainer id="home">
      <HeroBackground />
      <HeroContent>
        <HeroTitle>Love Your Skin</HeroTitle>
        <HeroSubtitle>L'art du tatouage et du piercing à Paris</HeroSubtitle>
        <HeroDescription>
          Bienvenue dans notre salon de tatouage et piercing.
          Nous proposons des services de qualité à des prix accessibles pour tous,
          avec une équipe d'artistes talentueux et confirmés capables de realiser tout les styles.
        </HeroDescription>
        <ButtonContainer>
          <StyledButton href="#artistes">Découvrir nos artistes</StyledButton>
          <StyledButton href="#tarifs">Voir nos tarifs</StyledButton>
        </ButtonContainer>
      </HeroContent>

      <SectionTitle>Nos valeurs :</SectionTitle>
      <FeatureContainer>
        <FeatureCard>
          <FeatureTitle>Prix abordables</FeatureTitle>
          <FeatureDescription>
          Rendre les tatouages et les piercings accessibles à tous grâce à des tarifs abordables
          </FeatureDescription>
        </FeatureCard>
        
        <FeatureCard>
          <FeatureTitle>Styles divers</FeatureTitle>
          <FeatureDescription>
          Permettre a chacun d'exprimer son individualité grâce à des artistes aux styles divers
          </FeatureDescription>
        </FeatureCard>
        
        <FeatureCard>
          <FeatureTitle>Securité</FeatureTitle>
          <FeatureDescription>
          Donner à chaque client un accompagnement personnalisé dans un environnement convivial et professionnel
          </FeatureDescription>
        </FeatureCard>
      </FeatureContainer>
    </HomeContainer>
  );
};

export default Home;
